module.exports = __webpack_public_path__ + "Roboto-BoldItalic.c2e0f75da3677f645034.svg";


//////////////////
// WEBPACK FOOTER
// /Users/rujuta/Desktop/Projects/agiletimes-master/node_modules/roboto-fontface/fonts/roboto/Roboto-BoldItalic.svg
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-BoldItalic.svg
// module chunks = styles